import {
    SurveysStatisticsDocument,
    SurveysStatisticsQuery,
    SurveysStatisticsQueryVariables,
    TenantModulesDocument,
} from '@graphql/generated/graphql';

import { ExcludedSurveyService } from '@services/ExcludedSurveyService';

import { useQuery, useReactiveVar } from '@apollo/client';
import { QueryHookOptions } from '@apollo/client/react/types/types';
import { authVar, tenantModulesVar } from '@boot/reactiveVariables';

interface UseSurveysStatisticsProps
    extends QueryHookOptions<
        SurveysStatisticsQuery,
        SurveysStatisticsQueryVariables
    > {}
export const useSurveysStatistics = (props: UseSurveysStatisticsProps) => {
    const isLoggedIn = useReactiveVar(authVar).isLoggedIn;
    const { data: tenantData } = useQuery(TenantModulesDocument, {
        onCompleted: ({ tenant }) => {
            tenantModulesVar(tenant.modules);
        },
        skip: !isLoggedIn,
    });
    const surveysDone = ExcludedSurveyService.getExcludedSurvey();
    const excludedUuids = surveysDone?.length ? surveysDone : undefined;

    return useQuery(SurveysStatisticsDocument, {
        skip: !tenantData?.tenant.modules.surveys || !isLoggedIn,
        variables: { excludedUuids },
        ...props,
    });
};
